import { useEffect, useRef } from 'react';

export default function InfiniteScrollSentinel({ hasMore, loading, onLoadMore, label = 'Loading more…' }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!hasMore || loading || !ref.current) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) onLoadMore();
      },
      { rootMargin: '240px 0px' }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [hasMore, loading, onLoadMore]);

  if (!hasMore && !loading) return null;
  return (
    <div ref={ref} className="infinite-scroll-sentinel" aria-live="polite">
      {loading ? label : 'Scroll to load more'}
    </div>
  );
}
